import { z } from 'zod'
import { ProseMirrorNode } from './answer.js'
import { Moment } from './moment.js'

/**
 * De gegevens van het processysteem bij een instantie (R-54, R-56, U11, `docs/koppelvlak.md`
 * hoofdstuk 4).
 *
 * Het processysteem geeft ze bij het uitzetten mee in het dossier-contract, met de aanduiding van die
 * stand (D-72). De opslagdienst toetst ze tegen het formulier en bewaart ze bij de instantie, apart van
 * `Instantie`, want een pod leest die vorm strikt. De pod begint het formulier ermee, en het bericht
 * meet ertegen wat de invuller veranderde.
 */

/** Zoals het processysteem ze meegeeft: per veldnaam in het processysteem de waarde, rich text als HTML. */
export const DeliveredDossierFields = z.strictObject({
  stand: z.string().min(1),
  velden: z.record(z.string().min(1), z.unknown()),
})
export type DeliveredDossierFields = z.infer<typeof DeliveredDossierFields>

/**
 * Zoals de opslagdienst ze bewaart en teruggeeft (`GET /v1/instanties/:id/dossiervelden`).
 *
 * `velden` is wat het processysteem meegaf, letterlijk: daartegen meet het bericht, en een rich-text-veld
 * gaat als die HTML terug in `<aangeleverd>`. `structuren` is per rich-text-veld dezelfde inhoud in de
 * vorm van de editor, met de grootte van elke figuur ingevuld; daarmee begint de pod het veld.
 * `moment` is wanneer het processysteem de gegevens meegaf: het moment van het aanmaakverzoek, één keer
 * vastgelegd, zodat elke plek die het formulier ermee begint dezelfde herkomst schrijft.
 *
 * Er komt hooguit een sleutel bij, nooit een die verandert of verdwijnt: een pod is bevroren en leest
 * deze vorm. De opslagdienst schrijft hem strikt; een pod laat een sleutel die hij niet kent liggen
 * (`apps/runtime/src/storeclient.ts`, `getDossierFields`).
 */
export const DossierFields = z.strictObject({
  stand: z.string().min(1),
  moment: Moment,
  velden: z.record(z.string().min(1), z.unknown()),
  structuren: z.record(z.string().min(1), ProseMirrorNode),
})
export type DossierFields = z.infer<typeof DossierFields>
